<template>
  <div class="model-search-form h-8 flex flex-col lg:flex-row lg:items-center">
    <div class="flex flex-1 flex-col lg:flex-row w-full lg:w-2/3 lg:mb-0 justify-between items-center">
      <div class="flex flex-row w-full">
        <div class="w-full flex flex-row justify-between">
          <search-input
            v-model="keyword"
            :placeholder="$t('models.model_search_form.model_title')"
            @search="handleSearch"
          />
          <div class="flex flex-row gap-x-4 items-center">
            <div v-if="modelSort"
                 class="flex flex-row items-center gap-x-2">
              <div class="sort-icon"></div>
              <a
                href="/profile/models/sorting"
                class="leading-[26px] text-[12px] hover:text-gray-200"
              >
              {{ $t(`post.state.shop_sort`) }}
              </a>
            </div>
            <span v-if="modelSort && createBtn" class="border-l border-gray-400 h-full hidden lg:block"></span>
            <button
              v-if="createBtn"
              @click="handleCreate"
              class="hidden lg:flex btn btn-primary py-1 max-h-8 items-center"
            >
              <img src="../../images/icons/upload.svg" class="w-6 h-6" alt="upload_model" />
              <span class="text-14px font-medium inline-block ml-2">{{ $t('models.model_search_form.upload') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import debounce from 'lodash/debounce';

export default {
  name: 'ModelSearchForm',
  props: {
    keyword: {
      type: String,
      default: ''
    },
    createBtn: {
      type: Boolean,
      default: false
    },
    modelSort: {
      type: Boolean,
      default: false
    }
  },
  emits: ['search'],
  setup(props, { emit }) {
    const keyword = ref(props.keyword || '');
    const hasSearched = ref(keyword !== '');
    const inputFocused = ref(false);

    const showCancelButton = computed(() => {
      return hasSearched.value && keyword.value && !inputFocused.value;
    });

    const debouncedSearch = debounce((value) => {
      emit('search', value);
    }, 300);

    const handleSearch = () => {
      hasSearched.value = keyword.value !== '';
      inputFocused.value = false;
      debouncedSearch(keyword.value);
    };

    const handleCancel = () => {
      keyword.value = '';
      hasSearched.value = false;
      debouncedSearch('');
    };

    const handleCreate = () => {
      window.location.href = '/profile/models/new';
    };

    return {
      keyword,
      inputFocused,
      showCancelButton,
      handleSearch,
      handleCancel,
      handleCreate
    };
  }
};
</script>
